
import browserSignature from "browser-signature";
import {actions} from "../app/modules/Auth/_redux/authRedux"

export const signature = localStorage.getItem("device") ?? browserSignature();

// Add device signature to localstorage if not present
if (!localStorage.getItem("device")){
  localStorage.setItem("device", signature)
}

export const apiHost = process.env.REACT_APP_API_HOST;

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {auth: { authToken, session } } = store.getState();
      /* Session Monitor */
      if (session.active && session.expire > new Date().getTime()) {
        /* Extend Session expiration by validity minutes */
        const currDate = new Date();
        currDate.setMinutes(currDate.getMinutes() + session.validity);
        session.expire = currDate.getTime();
        store.dispatch(actions.updateSession(authToken, session));
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      else if ((session.active && session.expire < new Date().getTime()) ){
        /* Force User re-authentication */
        session.active = false;
        store.dispatch(actions.updateSession(null, session));
        throw new axios.Cancel('Session Expired');
      }

      config.headers.Signature = signature;
      config.url = apiHost + config.url;

      return config;
    },
    err => Promise.reject(err)
  );

  // Response Interceptor
  axios.interceptors.response.use(response => {
      return response;
    }, 
    err => {
      // Skip processing if message is an object (e.g., { password: "..." })
      if (typeof err?.response?.data?.message === 'object') {
        return Promise.reject(err);
      }
    
      if (
        err?.response?.data?.message?.toLowerCase() === "access denied" ||
        err?.response?.data?.error?.toLowerCase() === "invalid token" ||
        err?.response?.data?.error?.toLowerCase() === "authorization required"
      ) {
        /* Force User re-authentication */
        const {auth: { session } } = store.getState();
        session.active = false;
        store.dispatch(actions.updateSession(null, session));
        throw new axios.Cancel('Session Expired');
      }
      return Promise.reject(err)
    }
  );
}
